import {
  ContinueMovieItem,
  DetailedMovieItem,
  MovieItem,
} from '../data/models/cinema';
import { IdNameType, SeasonEpisodeType } from '../types/others';

export type MainStackParams = MainStackMobileParams & MainStackTvParams;

type MainStackMobileParams = {
  LoginMobile: undefined;
  MainMobile: { action?: string } | undefined;
  PlayerMobile: {
    id?: number;
    item?: DetailedMovieItem;
    info?: SeasonEpisodeType;
    startPosition?: number;
    action?: string;
  };

  MainDialogMobile: {
    title: string;
    text: string;
    actions: {
      text: string;
      action?: string;
    }[];
    defaultAction?: string;
  };
  OptionsDialogMobile: { type: OptionsType };

  BlankMobile: undefined;
};

type MainStackTvParams = {
  LoginTv: undefined;
  MainTv: undefined;

  CollectionsTv: undefined;

  Tv: { id: number; date?: number; parentCode?: string } | undefined;
  CatalogTv: CatalogFilterParams | undefined;
  FilterDialogTv: {
    title: string;
    key: keyof CatalogFilterParams;
    selected?: number[];
    multiple?: boolean;
    mustHave?: boolean;
  };

  SearchTv: undefined;
  SearchFilterDialog: { query: string; filters: IdNameType[] };

  SearchMoviesResult: {
    tab: number;
    category: number;
    title?: string;
    query?: string;
  };
  SearchChannelsResult: {
    query: string;
  };
  SearchEpgResult: {
    query: string;
  };

  BookmarkTv: undefined;
  HistoryTv: undefined;
  FavoritesTv: undefined;

  DetailsTv: { id: number; tab: number };
  PlayerTv: {
    id?: number;
    item?: DetailedMovieItem;
    info?: SeasonEpisodeType;
    recommendations?: MovieItem[];
    startPosition?: number;
    action?: string;
  };

  SettingsTv: { action?: string; parentCode?: string } | undefined;
  OptionsDialogTv: { type: OptionsType };
  DebugDialogTv: undefined;

  ParentDialogTv: undefined;
  ParentPassDialogTv: undefined;

  ContinueWatchDialog: {
    item: ContinueMovieItem;
    history?: boolean;
  };

  BlankTv:
    | { id: number; info: SeasonEpisodeType; position: number }
    | undefined;

  MainDialogTv: {
    title: string;
    text: string;
    actions: {
      text: string;
      action?: string;
    }[];
    defaultAction?: string;
  };
};

export type MainTabsParams = {
  Main: undefined;
  Tv: { id?: number; date?: number } | undefined;
  Catalog: undefined;
  Search: undefined;
  More: undefined;
};

export type StackWithDetailsParams = {
  Details: { id: number };
};

export type HomeStackParams = {
  Root: undefined;
  Category: { category: number; title?: string; query?: string };
  Collections: undefined;
} & StackWithDetailsParams;

export type CatalogStackParams = {
  Root: CatalogFilterParams | undefined;
  FiltersDialog: CatalogFilterParams | undefined;
} & StackWithDetailsParams;

export type SearchStackParams = {
  Root: undefined;
  MoviesResult: { category: number; title?: string; query?: string };
  ChannelsResult: {
    query: string;
  };
  EpgResult: {
    query: string;
  };
} & StackWithDetailsParams;

export type SettingsStackParams = {
  Root: undefined;
  Favorites: undefined;
  History: undefined;
  Settings: undefined;
  ParentControl: undefined;
  ChannelsControl: undefined;
  About: undefined;
  Faq: undefined;
} & StackWithDetailsParams;

type CatalogFilterParams = {
  category?: number[];
  distributor?: number[];
  genre?: number[];
  year?: number[];
  country?: number[];
  sort?: number[];
};

export enum OptionsType {
  fontSize,
  mouseMode,
  startScreen,
  tvStart,
  bufferLength,
  seekStep,
  pipMode,
  tvBackButton,
}
